export const integerRegex = /^[\+\-]?\d*\.?\d+(?:[Ee][\+\-]?\d+)?$/;
export const specialCharacterRegex = "^(\d{1,3}([.]\d{1,4})?|-\d+([.]\d+)?)$";